import toMap from '~/misc/toMap';

export default toMap([
  'GET_PAYMENT_INFO',
  'HP_PAGE_ASYNG_ERROR_HIDE',
  'HP_GET_PLANS_INFO',
  'HP_CREATE_ORDER',
  'HP_SAVE_BASIC_INFO',
  'HP_PAY_ORDER',
  'HP_GET_PAYMENT_INFO',
  'HP_PALN_MODES_INIT',
  'JUDGE_IS_BUYER_OR_NOT',
]);



// WEBPACK FOOTER //
// ./src/modules/hp/types.js